<div class="relative flex">
  <mat-icon
    tabindex="0"
    class="material-icons-outlined hvs-icon-xxl absolute right-0 top-0 m-4 cursor-pointer"
    (click)="onCloseBtnClick()"
    (keydown.enter)="onCloseBtnClick()"
  >
    close
  </mat-icon>
  <div class="flex grow basis-2/5 flex-col">
    <div class="flex flex-col gap-4 p-10">
      <div class="flex items-start gap-4">
        <mat-icon
          class="material-icons-outlined !size-14 shrink-0 text-[56px] text-blue-dark"
          [svgIcon]="getCourseIcon()"
        ></mat-icon>
        <div class="flex flex-col gap-1">
          <p
            class="line-clamp-2 break-words text-2xl font-semibold text-blue-dark"
          >
            {{
              'portal.courses.courseTitleKeys.' + data.course.name + '.name'
                | transloco
            }}
          </p>
          <div
            class="flex flex-wrap items-center gap-2 text-sm font-light text-grey"
          >
            <span class="break-keep">
              {{ 'portal.topicAreas.' + data.course.topicAreaName | transloco }}
            </span>
            <span>•</span>
            <span>{{
              'portal.courses.courseDetailCardDialog.courseText' | transloco
            }}</span>
            <span>•</span>
            <span class="break-keep">
              {{
                'portal.courses.courseTitleKeys.' +
                  data.course.name +
                  '.duration' | transloco
              }}
            </span>
            <span>•</span>
            <div class="flex items-center gap-1 break-keep">
              <img
                src="assets/flags/de.svg"
                alt="Deutsch"
                title="Deutsch"
                class="flag-icon"
              />
              <span>/</span>
              <img
                src="assets/flags/gb.svg"
                alt="English"
                title="English"
                class="flag-icon"
              />
            </div>
          </div>
        </div>
      </div>
      <p class="text-sm font-light text-blue-dark">
        {{
          'portal.courses.courseTitleKeys.' + data.course.name + '.description'
            | transloco
        }}
      </p>
      @if (!data.isPrecuratedTraining) {
        <app-primary-button
          class="w-full"
          [text]="
            'portal.courses.courseDetailCardDialog.ctaBtnCourseDetailCard'
              | transloco
          "
          (buttonClicked)="openCourseSetup()"
        />
      }
    </div>
    @if (chapters && chapters.length > 0) {
      <div
        class="flex h-96 flex-col gap-4 overflow-y-auto border-t border-grey-lightGrey px-10 pb-10 pt-8"
      >
        @for (chapter of chapters; track i; let i = $index) {
          <div
            class="flex cursor-pointer flex-col gap-3 rounded-lg bg-grey-lightGrey px-5 py-4"
            tabindex="0"
            (keydown.enter)="toggle(i)"
            (click)="toggle(i)"
          >
            <div class="flex items-center justify-between">
              <div class="flex grow gap-2">
                <span class="break-words text-sm font-semibold">
                  {{ chapter.name }}
                </span>
                <span class="whitespace-nowrap text-sm text-grey">
                  {{ chapter.duration }}
                </span>
              </div>
              <mat-icon
                class="text-blue transition-transform duration-300"
                [class.rotate-180]="openChapters.includes(i)"
              >
                keyboard_arrow_down
              </mat-icon>
            </div>
            @if (openChapters.includes(i)) {
              <div class="text-sm font-light text-grey">
                {{ chapter.description }}
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <div
    class="flex shrink basis-3/5 flex-col gap-8 overflow-hidden bg-grey-veryLightGrey p-6 px-12 py-10"
  >
    <div class="flex flex-col gap-2">
      <p class="text-lg font-semibold text-blue-dark">
        {{ 'portal.courses.courseDetailCardDialog.title' | transloco }}
      </p>
      <p class="text-sm font-light text-grey">
        {{ 'portal.courses.courseDetailCardDialog.description' | transloco }}
      </p>
    </div>
    <div class="relative aspect-[16/9] w-full overflow-hidden rounded-xl">
      @if (safeUrl) {
        <iframe
          id="course-preview-id"
          [src]="safeUrl"
          class="absolute inset-0 size-full"
          allow="fullscreen"
          sandbox="allow-forms allow-modals allow-scripts allow-same-origin"
        ></iframe>
      } @else {
        <div class="flex size-full items-center justify-center">
          <app-loading class="size-12"></app-loading>
        </div>
      }
    </div>
  </div>
</div>
